import React from 'react';

import { Checkmark, CheckmarkContainer, ContainerLabel } from './Checkbox.styled';
import CheckmarkIcon from 'assets/icons/checkmark.svg?react';
import { Text } from 'components/v2/Typography/Text';
import theme from 'kb-shared/theme';

import { Props } from './Checkbox.types';

export const Checkbox = ({
  id,
  label,
  isChecked,
  onChange,
  size,
  isCheckedAndReviewed = false,
  className,
  disabled = false
}: Props) => {
  return (
    <ContainerLabel
      className={className}
      htmlFor={id}
      $disabled={disabled}
      $isChecked={isChecked}
      $isCheckedAndReviewed={isCheckedAndReviewed}
    >
      <input
        id={id}
        type="checkbox"
        className="v2"
        checked={isChecked}
        onChange={onChange}
        disabled={disabled}
      />
      <CheckmarkContainer $size={size}>
        <Checkmark $isCheckedAndReviewed={isCheckedAndReviewed}>
          <CheckmarkIcon />
        </Checkmark>
      </CheckmarkContainer>
      <Text size="md" color={disabled ? theme.colors.neutral.lighterNavy : ''}>
        {label}
      </Text>
    </ContainerLabel>
  );
};
